<div class="reservation-pannel">
    <div class="row m-0">
        <div class="col-lg-3 col-md-4 reservation-summery-layout">
            <app-activity-slot-summary></app-activity-slot-summary>
        </div>
        <div class="col-lg-9 col-md-8 reservation-guest-data" *ngIf="selectedIndex === 4">
            <!-- <app-activity-guest-edit></app-activity-guest-edit> -->
            <ng-container #comp *ngComponentOutlet="currentComponent"></ng-container>
        </div>
    </div>
</div>